module.exports = __webpack_public_path__ + "static/img/21.44a5268a.png";